import { appEntryData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
              移动端体验
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              {appEntryData.title}
            </h2>
            <p className="text-lg text-primary-600 font-medium mb-4">
              {appEntryData.subtitle}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {appEntryData.description}
            </p>

            <div className="flex flex-wrap gap-2 mb-8">
              {appEntryData.features.map((feat) => (
                <span
                  key={feat}
                  className="px-3 py-1.5 rounded-lg bg-background-50 text-foreground-600 text-xs font-medium border border-background-300 whitespace-nowrap"
                >
                  <i className="ri-check-line mr-1 text-primary-500"></i>
                  {feat}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="w-28 h-28 rounded-xl overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={appEntryData.qrCode}
                  alt="快看影视APP下载二维码"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-800 mb-1">扫码下载APP</p>
                <p className="text-xs text-foreground-500">支持 iOS / Android / iPad</p>
                <div className="flex gap-2 mt-3">
                  <button className="px-4 py-2 bg-foreground-900 text-background-50 rounded-lg text-xs font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors">
                    <i className="ri-apple-fill mr-1"></i>
                    App Store
                  </button>
                  <button className="px-4 py-2 bg-primary-500 text-background-50 rounded-lg text-xs font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors">
                    <i className="ri-android-fill mr-1"></i>
                    安卓下载
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-56 md:w-64">
              <img
                src={appEntryData.previewImage}
                alt="快看影视APP界面预览"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}